



import {computed, defineComponent} from "@vue/composition-api";

export default defineComponent({
    props: {
        value: {
            type: Boolean,
            required: true
        }
    },
    setup(props) {
        const classes = computed(() => {
            return ['badge', props.value ? 'badge-success' : 'badge-danger']
        });

        const text = computed(() => {
            return props.value ? 'Yes' : 'No';
        });

        return {
            classes,
            text,
        }
    }
})
